module.exports = __webpack_public_path__ + "static/14-colour-5df730ff10ee94de4ad13f5ceb839249.jpg";